export const getContentDispositionFilename = (value?: string): string | null => {
  if (!value) return null;

  const utf8Match = value.match(/filename\*=UTF-8''([^;]+)/i);
  if (utf8Match?.[1]) {
    try {
      return decodeURIComponent(utf8Match[1].trim().replace(/^"|"$/g, ''));
    } catch {
      return utf8Match[1].trim().replace(/^"|"$/g, '');
    }
  }

  const basicMatch = value.match(/filename=(?:"([^"]+)"|([^;]+))/i);
  return (basicMatch?.[1] || basicMatch?.[2] || '').trim() || null;
};
